import {ENDPOINT_DISASTER} from 'common/endpoints';
import {commonJwtHeader} from 'common/utils';

const getDeclarations = (searchStr) => {
  return fetch(
    `${ENDPOINT_DISASTER}disaster-declarations?searchString=${searchStr.toUpperCase()}`,
    {
      method: 'GET',
      headers: commonJwtHeader(),
    }
  );
};

const getDeclarationSummary = ({declarationType, disasterNumber, disasterState}) => {
  return fetch(
    `${ENDPOINT_DISASTER}disaster-incident-summary?disasterNumber=${disasterNumber}&declarationType=${declarationType}&state=${disasterState}`,
    {
      method: 'GET',
      headers: commonJwtHeader(),
    }
  );
};

const getDesignatedPrograms = ({disasterNumber, disasterState}) => {
  return fetch(
    `${ENDPOINT_DISASTER}designated-programs?disasterNumber=${disasterNumber}&state=${disasterState}`,
    {
      method: 'GET',
      headers: commonJwtHeader(),
    }
  );
};

const getDesignatedPlaces = ({
  disasterNumber,
  disasterState,
  programTypeCode,
  pageNumber,
  offset,
}) => {
  return fetch(
    `${ENDPOINT_DISASTER}designated-places?disasterNumber=${disasterNumber}&state=${disasterState}&programTypeCode=${programTypeCode}&pageNumber=${pageNumber}&pageSize=${offset}`,
    {
      method: 'GET',
      headers: commonJwtHeader(),
    }
  );
};

export default {
  getDeclarations,
  getDeclarationSummary,
  getDesignatedPrograms,
  getDesignatedPlaces,
};
